
export const bitmapToBlob = (bitmap: ImageBitmap): Promise<Blob | null> => {
  const canvas = document.createElement('canvas');
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const ctx = canvas?.getContext('bitmaprenderer');
  ctx?.transferFromImageBitmap(bitmap);
  const blob2 = new Promise<Blob | null>((res) => canvas.toBlob(res));
  return blob2
}

const getSize = (position: string, originalImage: HTMLImageElement) => {
  let dx = originalImage.width - (originalImage.width * 0.4)
  let dy = ((originalImage.height) - (originalImage.height * 0.4))

  switch (position) {
    case "TOPLEFT": {
      return { x: 0, y: 0 }
    }
    case "TOPRIGHT": {
      return { x: originalImage.width - dx, y: 0 }
    }
    case "BOTTOMLEFT": {
      return { x: 0, y: originalImage.height - dy }
    }
    case "BOTTOMRIGHT": {
      return { x: originalImage.width - dx, y: originalImage.height - dy }
    }
    case "CENTER": {
      return { x: (originalImage.width - dx) / 2, y: (originalImage.height - dy) / 2 }
    }
    default: {
      return { x: 0, y: 0 }
    }
  }
}

export const cropImage = async (source: string | Blob | MediaSource, width: number, height: number, type: "TOPLEFT" | "TOPRIGHT" | "BOTTOMLEFT" | "BOTTOMRIGHT" | "CENTER", id: string, setCropImage) => {
  const originalImage = new Image()

  originalImage.onload = async () => {
    var canvas = document.getElementById(id) as HTMLCanvasElement | null
    const ctx = canvas?.getContext('2d')
    const { x, y } = getSize(type, originalImage)

    await new Promise<string>((resolve, reject) => {
      let dx = originalImage.width - (originalImage.width * 0.4)
      let dy = ((originalImage.height) - (originalImage.height * 0.4))

      if (canvas) {
        canvas.width = dx;
        canvas.height = dy;
      }
      ctx?.drawImage(originalImage, x, y, dx, dy, 0, 0, dx, dy);
      if (canvas) {
        setCropImage(canvas.toDataURL("image/jpeg", 1))
        resolve(canvas.toDataURL("image/jpeg", 1))
      }
    });
  }

  if (typeof source === "object") {
    let url = window.URL.createObjectURL(source)
    originalImage.src = url
  } else {
    originalImage.src = source
  }
}